var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3057 8.39174L27.2623 8.42064L27.5727 40.9125L34.9912 40.884L34.3057 8.39174Z",
    fill: "#D8D2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1681 40.8858C27.0417 40.9144 21.2355 33.6643 21.1994 24.6922C21.1634 15.7202 26.9113 8.42366 34.0377 8.39506C41.1641 8.36645 46.9704 15.6166 47.0064 24.5886C47.0424 33.5607 41.2945 40.8572 34.1681 40.8858Z",
    fill: "#D8D2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3595 17.9508L44.7287 17.9136C44.9313 18.4745 45.1122 19.0499 45.2666 19.6409L35.3664 19.6807L35.3595 17.9508Z",
    fill: "#8764FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6046 27.5352L36.5977 25.8053L45.8672 25.7668C45.8365 26.352 45.7796 26.9304 45.7006 27.4985L36.6046 27.5352Z",
    fill: "#8764FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3056 21.8702L45.6989 21.8396C45.7786 22.4065 45.8356 22.9832 45.8674 23.5702L38.3149 23.5996L38.3056 21.8702Z",
    fill: "#8764FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4126 14.035L42.7198 13.9938C43.0977 14.5377 43.4454 15.1152 43.762 15.7216L32.42 15.7673L32.4126 14.035Z",
    fill: "#8764FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8776 11.8034L29.4735 11.8497L29.4666 10.1198L38.6965 10.0821C39.4714 10.5647 40.2019 11.1435 40.8776 11.8034Z",
    fill: "#8764FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3772 37.4584L40.9794 37.4193C40.3074 38.0851 39.5836 38.6698 38.8121 39.1578L31.3841 39.1883L31.3772 37.4584Z",
    fill: "#8764FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5386 33.5937L43.7962 33.5531C43.4798 34.1613 43.1297 34.7393 42.7535 35.288L33.546 35.3259L33.5386 33.5937Z",
    fill: "#8764FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8303 31.4676L34.8234 29.7378L45.2693 29.6947C45.1163 30.2883 44.9373 30.8651 44.7328 31.4273L34.8303 31.4676Z",
    fill: "#8764FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5746 40.9088C20.4482 40.9374 14.642 33.6873 14.6059 24.7152C14.5699 15.7431 20.3178 8.44661 27.4442 8.41801C34.5706 8.3894 40.3769 15.6395 40.4129 24.6116C40.4489 33.5837 34.701 40.8802 27.5746 40.9088Z",
    fill: "#D8D2FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1888 12.6678C38.214 14.9932 39.6478 18.1188 40.1805 21.6481L21.9601 39.3239C19.4418 37.8054 17.3755 35.285 16.0796 32.1775L36.1888 12.6678Z",
    fill: "#E7E3FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.012 11.4727L15.455 30.4438C14.9916 28.9169 14.704 27.281 14.6272 25.5733L31.4845 9.22055C32.757 9.74226 33.9442 10.508 35.012 11.4727Z",
    fill: "#E7E3FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7775 37.9411C23.621 37.9618 19.4169 32.0317 19.3874 24.696C19.358 17.3602 23.5143 11.3966 28.6708 11.3759C33.8274 11.3552 38.0314 17.2852 38.0609 24.621C38.0903 31.9568 33.934 37.9204 28.7775 37.9411Z",
    fill: "#B9B1F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7775 37.9411C23.621 37.9618 19.4169 32.0317 19.3874 24.696C19.358 17.3602 23.5143 11.3966 28.6708 11.3759C33.8274 11.3552 38.0314 17.2852 38.0609 24.621C38.0903 31.9568 33.934 37.9204 28.7775 37.9411Z",
    fill: "#B9B1F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M36.1888 12.6678C38.214 14.9932 39.6478 18.1188 40.1805 21.6481L21.9601 39.3239C19.4418 37.8054 17.3755 35.285 16.0796 32.1775L36.1888 12.6678Z",
    fill: "#E7E3FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M35.012 11.4727L15.455 30.4438C14.9916 28.9169 14.704 27.281 14.6272 25.5733L31.4845 9.22055C32.757 9.74226 33.9442 10.508 35.012 11.4727Z",
    fill: "#E7E3FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2203 11.3908C22.2932 13.8703 19.7879 17.902 19.8162 24.7071C19.8448 32.0437 23.2841 37.1544 28.5706 37.856C28.6473 37.8548 28.7259 37.8506 28.8021 37.847C28.3928 37.9084 27.9809 37.9455 27.559 37.9475C21.7316 37.971 16.9849 32.0437 16.9563 24.7071C16.9288 17.4697 21.5028 11.57 27.2203 11.3908Z",
    fill: "#8764FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8579 13.8607L11.3746 8.04121L10.6331 13.8367L6.90723 14.3455L10.6068 14.9973L11.0955 20.5363L11.8316 15.0212L15.5575 14.5125L11.8579 13.8607Z",
    fill: "url(#paint0_linear_275_386)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86288 20.3166L5.59336 16.7353L5.18402 20.3018L3.11376 20.6117L5.17044 21.0146L5.44288 24.4245L5.84934 21.0316L7.91957 20.7195L5.86288 20.3166Z",
    fill: "url(#paint1_linear_275_386)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_275_386",
    x1: 11.1807,
    y1: 8.04277,
    x2: 11.2817,
    y2: 20.5348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8764FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A92FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_275_386",
    x1: 5.48489,
    y1: 16.7362,
    x2: 5.54705,
    y2: 24.4236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8764FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A92FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.ed10b216b59a0302161a658951e800ed.svg";
export { ForwardRef as ReactComponent };